import React from "react";
import styles from './styles.module.css';

export interface LinkFooterProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  text?: string;
  link?: string;
  target?: "_blank" | "_self";
  describeText?: string;
};

export const LinkFooter = ({
  link = "#",
  target = "_self",
  describeText,
  text = "Preencher",
  ...props
}: LinkFooterProps) => {
  return (
    <a
      className={styles.linkFooter}
      href={link}
      target={target}
      role="link"
      aria-label={describeText ? describeText : text}
      {...props}
      >
      {text}
    </a>
  )
};
